/* 
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
*/

import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import appRoutes from "../../routes/appRoutes";

import PublicLayout from "../../containers/Layout/PublicLayout";
import Label from "../../components/label";

import LogoImg from "../../assets/images/group-3@3x.png";

class SignupSuccess extends Component {
  render() {
    return (
      <PublicLayout>
        <div className="container signup-success">
          <div className="row">
            <div className="col-sm-8 offset-sm-2 p-5 text-center bg-white rounded">
              <img
                src={LogoImg}
                alt="instant-consult-logo"
                className="logo mt-3"
              />
              <Label
                className="primary-color w-100 large primary-color mt-5"
                title="Thank you for Signing Up!"
              />
              <Label
                className="mt-3"
                title="Thank you for registering your interest in "
              />
              <Label
                title="Instant Consult"
                className="primary-color ml-1 mt-3"
              />
              <Label
                className="mt-3"
                title="Your application is being processed and you will receive an email from us shortly"
              />
              <Label
                className="mt-3"
                title="We look forward to welcoming you aboard our online medical practice"
              />
              <br />
              <NavLink
                to={appRoutes.login}
                className="btn insta-button-primary back-to-home mt-5"
                href="#"
              >
                <span className="ml-2 pt-1">Back to Home</span>
              </NavLink>
            </div>
          </div>
        </div>
      </PublicLayout>
    );
  }
}

export default SignupSuccess;
